import React from 'react'

import Logo from '../../shared/logo'
import SignInFooter from '../../shared/footer/signinFooter'
import SignInForm from './signInForm'
import ButtonLoginWrapper from './buttonLoginWrapper'
import SignInValidateResuld from './signInValidateResuld'

import styles from './signIn.module.scss'

const SignIn = () => {
  return (
    <div className={styles.signInWrapper}>
      <div className={styles.signInForm}>
        <div className={styles.logo_container}>
          <Logo />
        </div>

        <SignInForm />

        <div className={styles.button_container}>
          <ButtonLoginWrapper />
        </div>

        <SignInValidateResuld />
      </div>

      <SignInFooter />
    </div>
  )
}

export default React.memo(SignIn)